import { FC } from 'react'
import shallow from 'zustand/shallow'
import { useCompanySettingsStore } from '../CompanySettingsStore'
import { PerEmpty } from '../../../components/custom_components/Empty'
import { useTranslation } from 'react-i18next'
import BackgroundBox from '../../../components/custom_components/BackgroundBox'
import { useCultivatingTalentsIsEnabled } from '../../../graphql/talents-season/useRankingIsEnabled'
import { LoadingAndErrors } from '../../../components/custom_components/LoadingAndErrors'
import { CultivatingTalentsView } from './CultivatingTalentsView'

interface CultivatingTalentsViewProps {
  isYourCompanyView: boolean
}

export const CompanySettingsCultivatingTalentsTab: FC<CultivatingTalentsViewProps> = ({ isYourCompanyView }) => {
  const { t } = useTranslation()
  const [selected] = useCompanySettingsStore((state) => [state.selected], shallow)
  const { companyId, country } = selected

  const {
    data: cultivatingTalentsData,
    error: cultivatingTalentsError,
    loading: cultivatingTalentsLoading,
  } = useCultivatingTalentsIsEnabled(companyId, country)

  if (cultivatingTalentsLoading || cultivatingTalentsError || !cultivatingTalentsData) {
    return (
      <LoadingAndErrors
        isLoading={cultivatingTalentsLoading}
        hasNoData={!cultivatingTalentsData}
        error={cultivatingTalentsError}
        showSpinner
      />
    )
  }

  return cultivatingTalentsData.isCultivatingTalentsEnabledForCompanyAndCountry ? (
    <CultivatingTalentsView
      companyId={companyId}
      country={country}
      isHRSettings={false}
      isAllCompaniesSettings={!isYourCompanyView}
      isYourCompanyView={isYourCompanyView}
    />
  ) : (
    <BackgroundBox color="white75" r>
      <PerEmpty iconSize="m" icon="empty_stroke" heading={t('companySettingsView.rankingTab.cultivatingTalentsDisabled')} />
    </BackgroundBox>
  )
}
